import React, { Component } from 'react';
import TrafficSignsMessagesModel from './TrafficSignsMessagesModel';
import SignView from './SignView';

import { Spin, Tooltip } from 'antd';
import moment from 'moment';

class TrafficSignsActualView extends Component {
    state = {
        serialNumber: this.props.serialNumber,
        text: null,
        textAlign: null,
        width: null,
        background: null,
        color: null,
        timestamp: null
    }
    componentWillMount() {
        if (this.props.serialNumber) {
            TrafficSignsMessagesModel.getLastMsg(this.props.serialNumber)
                .then((res) => {
                    if (res[0].fullMessage) {
                        let parts = res[0].fullMessage.split(";");
                        var text = parts[7];
                        let align = this.getAlign(parts[5]);
                        var color = this.getColor(parts[4]);
                        const regex = /^\\(.)(.*)$/;
                        const matches = text.match(regex);
                        if (matches) {
                            color = this.getColor(matches[1]);
                            text = matches[2];
                        }
                        this.setState({ text: text, width: 200, textAlign: align, background: this.getColor(parts[3]), color: color, timestamp: moment(res[0].updatedAt ? res[0].updatedAt : res[0].createdAt).format('L LTS') });
                    } else {
                        this.setState({ text: ' ', textAlign: 'center', width: 250, background: 'black', color: 'black' });
                    };
                })
                .catch((err) => {
                    console.log(err);
                })
        }
    }
    getColor(char) {
        switch (char) {
            case 'K':
                return 'black';
            case 'W':
                return 'white';
            case 'R':
                return 'red';
            case 'G':
                return 'lightgreen';
            case 'B':
                return 'blue';
            case 'C':
                return 'cyan';
            case 'M':
                return 'magenta';
            case 'Y':
                return 'yellow';
            default:
                return 'white';
        }
    };

    getAlign(char) {
        switch (char) {
            case 'C':
                return 'center';
            case 'L':
                return 'left';
            case 'R':
                return 'right';
            default:
                return 'center';
        }
    }


    render() {
        return (
            <React.Fragment>
                {(this.state.text) ? <SignView text={this.state.text} textAlign={this.state.textAlign} width={this.state.width} background={this.state.background} color={this.state.color} tooltip={this.state.timestamp} /> : this.props.serialNumber ? <Spin /> : '-'}
            </React.Fragment>
        );
    }

}

export default TrafficSignsActualView


// WEBPACK FOOTER //
// ./src/components/TrafficSignActualView.js